<template>
	<v-layout row wrap>
		<v-flex xs12 md8>
			<v-layout row wrap>
				<v-flex xs12>
					<ValidationProvider name="title" v-slot="{ errors, valid }">
						<form-localized-input
							v-model="item.title"
							:errors="errors"
							:valid="valid"
						>
						</form-localized-input>
					</ValidationProvider>
				</v-flex>
				<v-flex xs12 md12>
					<v-autocomplete
						:items="type"
						:label="$t('label.type')"
						v-model="item.type"
						data-vv-name="type"
						required
						filled
						class="required"
					>
					</v-autocomplete>
				</v-flex>
				<v-flex xs12 md12 v-if="item.type == 'day'">
					<v-layout row wrap>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.mon"
								label="Mon"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.tue"
								label="Tue"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.wed"
								label="Wed"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.thu"
								label="Thu"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.fri"
								label="Fri"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.sat"
								label="Sat"
								hide-details
							></v-checkbox>
						</v-flex>
						<v-flex xs12 md2>
							<v-checkbox
								v-model="item.sun"
								label="Sun"
							></v-checkbox>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md12 v-if="item.type == 'date_range'">
					<v-layout row wrap>
						<v-flex xs12 md6>
							<v-text-field
								v-model="item.start_date"
								:label="$t('label.start_date')"
								type="date"
								data-vv-name="start_date"
								filled
								class="required"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md6>
							<v-text-field
								v-model="item.end_date"
								:label="$t('label.end_date')"
								type="date"
								data-vv-name="end_date"
								filled
								class="required"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md12 v-if="item.type">
					<v-layout row wrap>
						<v-flex xs12 md6>
							<v-text-field
								v-model="item.start_time"
								type="time"
								:label="$t('label.start_time')"
								data-vv-name="start_time"
								required
								filled
								class="required"
							></v-text-field
						></v-flex>
						<v-flex xs12 md6>
							<v-text-field
								v-model="item.end_time"
								type="time"
								:label="$t('label.end_time')"
								data-vv-name="end_time"
								required
								filled
								class="required"
							></v-text-field
						></v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<ValidationProvider
						name="description"
						v-slot="{ errors, valid }"
					>
						<form-localized-editor
							v-model="item.description"
							:errors="errors"
							:valid="valid"
						>
						</form-localized-editor>
					</ValidationProvider>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 class="pl-10">
			<v-layout row wrap>
				<v-flex xs12 md12>
					<v-card>
						<v-card-title primary-title>
							<h3>{{ $t("label.cover_image") }}</h3>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<app-media-library
								v-model="item.image"
								:data="data"
							></app-media-library>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="item.read_more_link"
						:label="$t('label.read_more_link')"
						data-vv-name="read_more_link"
						filled
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		props: ["value", "data"],
		data() {
			return {
				restaurants: [],
				locations: [],
				type: [
					{
						text: "Day",
						value: "day",
					},
					{
						text: "Everyday",
						value: "everyday",
					},
					{
						text: "Weekends only",
						value: "weekends_only",
					},
					{
						text: "Date range",
						value: "date_range",
					},
				],
			};
		},
		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
	};
</script>
